function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1417",
  "data-name": "Group 1417",
  transform: "translate(785.375 -833.954)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1358",
  "data-name": "Group 1358",
  transform: "translate(-780 834)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_236",
  "data-name": "Path 236",
  d: "M5.177.7a1.01,1.01,0,0,0-1.416.01L.351,4.118a.5.5,0,0,0,.006.705h0a.5.5,0,0,0,.709,0L4,1.886V16.5a.507.507,0,0,0,.5.5h0a.5.5,0,0,0,.5-.5V1.941L7.935,4.832a.51.51,0,0,0,.708-.008h0a.5.5,0,0,0,0-.705Z",
  fill: "#25a4b4",
  stroke: "#25a4b4",
  strokeWidth: 0.75
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1362",
  "data-name": "Group 1362",
  transform: "translate(-785 842.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_241",
  "data-name": "Path 241",
  d: "M14.5,0a.507.507,0,0,0-.5.5h0a.5.5,0,0,0,.491.5H18V18H1V1H4.509A.5.5,0,0,0,5,.5H5A.507.507,0,0,0,4.5,0H1A1,1,0,0,0,0,.995V18.006A1,1,0,0,0,.995,19h17.01A1,1,0,0,0,19,18.006V.995A.992.992,0,0,0,18,0Z",
  fill: "#25a4b4",
  stroke: "#25a4b4",
  strokeWidth: 0.75
})));

var SvgIconShare = function SvgIconShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.75,
    height: 27.922,
    viewBox: "0 0 19.75 27.922",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-share.5006f8df.svg";
export { ForwardRef as ReactComponent };